<template>
<v-dialog v-model="dialog" width="500" >
  <template v-slot:activator="{ on, attrs }">
    <v-btn v-bind="attrs" v-on="on" text small >
      Revert to default
    </v-btn>
  </template>
  <v-card>
    <request-status :request="req" @ok="reverted" />
  <v-card-title class="overline py-0 grey lighten-4" >
    Please confirm
    <v-spacer/>
    <v-btn @click="dialog=false" icon small ><v-icon small >mdi-close</v-icon></v-btn>
  </v-card-title>
  <v-card-text class="mt-5 text-subtitle-1" >
    Are you sure you want to revert your customizations?
  </v-card-text>
  <v-card-actions >
    <v-btn @click="dialog=false" text >Cancel</v-btn>
    <v-spacer/>
    <v-btn :disabled="!slug" @click="revert" color="error" >Revert to default message</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'RevertToDefault',
  props: {
    value: {type: Object, required: true}
  },
  data () {
    return {
      dialog: false,
      req: {
        resource: 'ag.practitioner.notifications'
      }
    }
  },
  computed: {
    slug () { return this.getObjectPath(this.value, 'slug') }
  },
  methods: {
    revert () {
      this.req.resourceId = this.slug
      this.$request('delete', this.req)
    },
    reverted (req) {
      this.dialog = false
      this.$emit('reverted', req)
    }
  }

}
</script>
